import { render, staticRenderFns } from "./arAging.vue?vue&type=template&id=50992ebc&scoped=true"
import script from "./arAging.vue?vue&type=script&lang=js"
export * from "./arAging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50992ebc",
  null
  
)

export default component.exports